<div class="container">
  <img src="assets/images/logo-404.png">
  <h1 class="404-title">{{'NOT_FOUND.TITLE' | i18next}}</h1>
  <h3>{{'NOT_FOUND.404_NOT_FOUND' | i18next}}</h3>
  <p>{{'NOT_FOUND.WHY_NOT_GO_BACK_TO' | i18next}} <a href="/app/applications">{{'NOT_FOUND.HOME' | i18next}}</a> {{'NOT_FOUND.AND_TRY_SOMETHING_ELSE' | i18next}}</p>
</div>

